<!-- Generated template for the MysportProfileListItemComponent component -->

<ion-item>
	<ion-avatar item-start>
		<img src="{{profile.imageLink}}">
	</ion-avatar>
	<h6>
      {{profile.userName}}
    </h6>
</ion-item>